import { Component, OnInit } from '@angular/core';
import { BackdropService } from 'src/app/service/backdrop.service';

@Component({
  selector: 'app-backdrop',
  templateUrl: './backdrop.component.html',
  styleUrls: ['./backdrop.component.scss']
})
export class BackdropComponent implements OnInit {

  constructor(private backdropService: BackdropService) {
  }

  get showBackdrop(): boolean {
    return this.backdropService.isVisible
  }

  ngOnInit(): void {
  }

}
